import styles from './BuyBox.module.scss';

export const renderBuyBoxLoadPlaceholder = () => (
  <div className="bg-gray-50 flex items-center justify-center" style={{ height: '50rem' }}>
    <div data-testid="spinner" className={styles.spinner} />
  </div>
);
